<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">help_outline</span>
      <h2>Questions fréquentes (FAQ)</h2>
    </div>

    <p class="section-intro">
      Retrouvez ici les réponses aux questions les plus fréquemment posées par les utilisateurs de ComptaMiton.
    </p>

    <!-- Q1 -->
    <div class="faq-item">
      <div class="faq-question">Comment modifier mon mot de passe ?</div>
      <div class="faq-answer">
        Cliquez sur votre nom d'utilisateur en haut à droite de l'écran, puis sélectionnez <strong>Profil</strong>.
        Saisissez votre ancien mot de passe, le nouveau, confirmez-le et cliquez sur <span class="btn-ref">Soumettre</span>.
      </div>
    </div>

    <!-- Q2 -->
    <div class="faq-item">
      <div class="faq-question">Je n'arrive pas à me connecter. Que faire ?</div>
      <div class="faq-answer">
        Vérifiez que vous utilisez le bon identifiant (email ou téléphone) et le bon mot de passe.
        Si le problème persiste, contactez l'administrateur pour réinitialiser votre mot de passe.
        Lors de la première connexion, le mot de passe par défaut est <strong>0000</strong>.
      </div>
    </div>

    <!-- Q3 -->
    <div class="faq-item">
      <div class="faq-question">Je ne vois pas certains modules dans le menu. Pourquoi ?</div>
      <div class="faq-answer">
        Les modules visibles dépendent de votre rôle. Un caissier ne voit pas les mêmes modules qu'un administrateur.
        Si vous pensez qu'il manque un module, demandez à l'administrateur de vérifier vos droits d'accès.
      </div>
    </div>

    <!-- Q4 -->
    <div class="faq-item">
      <div class="faq-question">Comment ajouter un produit qui n'existe pas dans la liste ?</div>
      <div class="faq-answer">
        Les produits sont créés dans le module <strong>Paramétrage → Onglet Produits</strong>. Seul l'administrateur peut créer de nouveaux produits.
        Demandez à l'administrateur d'ajouter le produit avant de pouvoir l'utiliser dans les commandes ou le stock.
      </div>
    </div>

    <!-- Q5 -->
    <div class="faq-item">
      <div class="faq-question">Le bouton « Soumettre » est grisé. Que se passe-t-il ?</div>
      <div class="faq-answer">
        Cela signifie qu'un ou plusieurs champs obligatoires ne sont pas remplis.
        Vérifiez tous les champs marqués d'un astérisque rouge <span style="color:#e53935">*</span>.
        Une fois tous les champs remplis, le bouton devient actif.
      </div>
    </div>

    <!-- Q6 -->
    <div class="faq-item">
      <div class="faq-question">Comment annuler une commande envoyée à la caisse ?</div>
      <div class="faq-answer">
        Une commande envoyée à la caisse ne peut plus être annulée depuis le module Commandes.
        Contactez l'administrateur pour une annulation manuelle.
        C'est pourquoi il est important de vérifier la commande avant de cliquer sur <span class="btn-ref">Envoyer à la caisse</span>.
      </div>
    </div>

    <!-- Q7 -->
    <div class="faq-item">
      <div class="faq-question">Comment exporter un rapport en Excel ?</div>
      <div class="faq-answer">
        Dans le module <strong>Statistiques</strong>, générez d'abord le rapport en cliquant sur
        <span class="btn-ref">Charger les données</span>, puis cliquez sur <span class="btn-ref">Exporter EXCEL</span>.
        Le fichier .xlsx est téléchargé automatiquement.
      </div>
    </div>

    <!-- Q8 -->
    <div class="faq-item">
      <div class="faq-question">Le stock affiché ne correspond pas au stock physique. Comment corriger ?</div>
      <div class="faq-answer">
        Utilisez le module <strong>Inventaire</strong> pour déclarer l'écart (manquant ou excédent).
        L'administrateur validera l'ajustement dans le module <strong>Pertes &amp; Manquants</strong>.
        Ne modifiez jamais le stock directement — passez toujours par la procédure d'inventaire.
      </div>
    </div>

    <!-- Q9 -->
    <div class="faq-item">
      <div class="faq-question">Comment créditer le portefeuille d'un client ?</div>
      <div class="faq-answer">
        Allez dans le module <strong>Caisse</strong>, trouvez le client et cliquez sur l'icône de portefeuille.
        Saisissez le montant, le motif et le mode de paiement, puis cliquez sur <span class="btn-ref">Soumettre</span>.
      </div>
    </div>

    <!-- Q10 -->
    <div class="faq-item">
      <div class="faq-question">Comment supprimer un élément (produit, client, fournisseur) ?</div>
      <div class="faq-answer">
        Cliquez sur l'icône <span class="material-icons-sharp" style="font-size:14px;vertical-align:middle;color:#e53935">delete</span> dans le tableau.
        Une boîte de dialogue vous demande de confirmer. Cliquez sur <span class="btn-ref">Oui je veux</span> pour supprimer définitivement.
        <strong>Attention :</strong> la suppression est irréversible.
      </div>
    </div>

    <!-- Q11 -->
    <div class="faq-item">
      <div class="faq-question">Comment vérifier la localisation GPS d'un magasin ?</div>
      <div class="faq-answer">
        Dans le module <strong>Paramétrage → Onglet Magasins</strong>, cliquez sur un magasin puis sur
        <span class="btn-ref">Vérifier la localisation</span>. Une carte s'ouvre avec la position GPS du magasin.
      </div>
    </div>
  </div>
</template>
<script>
export default { name: "DocFaq" };
</script>
